import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function VerticalBarChart(iconSrc) {
  const data = {
    labels: ["January", "February", "March", "April", "May"],
    datasets: [
      {
        label: "Sales",
        data: [122, 19, 3, 5, 2, 3],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const iconPlugin = {
    id: "iconPlugin",
    afterDraw: (chart) => {
      const { ctx, scales } = chart;
      const yScale = scales.y;
      const labels = yScale.ticks.map((tick) => tick.label);

      labels.forEach((label, index) => {
        const iconUrl = iconSrc[index];
        if (iconUrl) {
          const image = new Image();
          image.src = iconUrl;
          image.onload = () => {
            const yPos = yScale.getPixelForTick(index) - image.height / 2;
            ctx.drawImage(image, yScale.left - image.width - 10, yPos, 24, 24);
          };
        }
      });
    },
  };

  const options = {
    plugins: {
      // 라벨 숨기기
      legend: {
        display: false,
      },
    },
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false, // 세로로 꽉 채우기 위해 비율 유지 안 함
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "400px" }}>
      {iconSrc[0]}
      <Bar data={data} options={options} plugins={[iconPlugin]} />
    </div>
  );
}

export default VerticalBarChart;
